module.exports = __webpack_public_path__ + "media/fonts/Oswald-Regular-8cc48b06d9597b006e4eece76e228ae5.woff";